import {
  BarChart3,
  ClipboardCheck,
  Database,
  GitCompare,
  type LucideIcon,
} from "lucide-react";

import type { TaxClosingTabs } from "@/services/tax-closing";

import { AuditTable } from "./audit-table";
import { DynamicsVsBookTab } from "./dynamics-vs-book-tab";
import { ModeloCfopCstTab } from "./modelo-cfop-cst-tab";
import { VarTab } from "./var-tab";

/**
 * Tab keys are stable and used in the URL (`?tab=...`). Keep them in
 * English and stable forever — translating the keys breaks bookmarks.
 * The user-facing labels live in Portuguese on the `label` field.
 */
export type TaxClosingTabKey =
  | "audit"
  | "modelo-cfop-cst"
  | "dynamics-vs-book"
  | "var";

export interface TaxClosingTabRenderContext {
  data: TaxClosingTabs;
  jobId: string;
}

export interface TaxClosingTabConfig {
  key: TaxClosingTabKey;
  label: string;
  Icon: LucideIcon;
  render: (ctx: TaxClosingTabRenderContext) => JSX.Element;
}

export const TAX_CLOSING_TABS: Record<TaxClosingTabKey, TaxClosingTabConfig> = {
  audit: {
    key: "audit",
    label: "Conferências",
    Icon: ClipboardCheck,
    render: ({ jobId }) => <AuditTable jobId={jobId} />,
  },
  "modelo-cfop-cst": {
    key: "modelo-cfop-cst",
    label: "Modelo x CFOP x CST",
    Icon: BarChart3,
    render: ({ data, jobId }) => <ModeloCfopCstTab data={data.modeloCfopCst} jobId={jobId} />,
  },
  "dynamics-vs-book": {
    key: "dynamics-vs-book",
    label: "Dinâmica vs Livro",
    Icon: GitCompare,
    render: ({ data }) => <DynamicsVsBookTab data={data.dinamicaVsLivro} />,
  },
  var: {
    key: "var",
    label: "VAR",
    Icon: Database,
    render: ({ data, jobId }) => <VarTab data={data.var} jobId={jobId} />,
  },
};

export const TAX_CLOSING_TAB_ORDER: TaxClosingTabKey[] = [
  "audit",
  "modelo-cfop-cst",
  "dynamics-vs-book",
  "var",
];

export const DEFAULT_TAX_CLOSING_TAB: TaxClosingTabKey = "audit";

export function isTaxClosingTabKey(value: string | null): value is TaxClosingTabKey {
  return value !== null && value in TAX_CLOSING_TABS;
}
